import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../../apiEcommerce";

export const addCart = createAsyncThunk(
  "cart/addCart",
  async ({ eco_products_id, count, color_id }, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/cart/updateOrCreate`,
        { eco_products_id, count, color_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error add to cart:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to add to cart"
      );
    }
  }
);

export const fetchAllOrdersCart = createAsyncThunk(
  "ordersCart/fetchAllOrdersCart",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.get(`/api/ecomerce/cart/getall`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid code.");
      }

      return response.data.data.orders;
    } catch (error) {
      console.error("Error fetching order:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch order"
      );
    }
  }
);

export const removeCart = createAsyncThunk(
  "cart/removeCart",
  async ({ cart_id }, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/cart/remove`,
        { cart_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error remove to cart:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to remove to cart"
      );
    }
  }
);

const initialState = {
  cart: [],
  ordersCart: [],
  status: "idle",
  error: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCart.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cart = action.payload;
      })
      .addCase(addCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchAllOrdersCart.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllOrdersCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ordersCart = action.payload;
      })
      .addCase(fetchAllOrdersCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(removeCart.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(removeCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cart = action.payload;
      })
      .addCase(removeCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addMatcher(
        (action) => action.type === removeCart.fulfilled.toString(),
        (state, action) => {
          state.status = "loading";
        }
      )
      .addMatcher(
        (action) => action.type === fetchAllOrdersCart.fulfilled.toString(),
        (state, action) => {
          state.status = "succeded";
        }
      );
  },
});

export default cartSlice.reducer;
